export default __webpack_public_path__ + "static/media/screen4.30517ea2.png";